function setFilterState(isVisible) {
  const filterBtn = document.querySelector(".filter-cstm-title");
  const filterBox = document.getElementById("FacetFiltersForm");
  const textSpan = filterBtn?.querySelector(".filter-text");

  if (!filterBtn || !filterBox || !textSpan) return;

  if (isVisible) {
    filterBox.style.display = "block";          
    filterBtn.classList.add("active");
    textSpan.textContent = "Hide Filters";
  } else {
    filterBox.style.display = "none";           
    filterBtn.classList.remove("active");
    textSpan.textContent = "Show Filters";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const filterBtn = document.querySelector(".filter-cstm-title");
  const filterBox = document.getElementById("FacetFiltersForm");

  if (!filterBtn || !filterBox) return;

  if (window.innerWidth >= 768) {
    setFilterState(false);
    filterBtn.addEventListener("click", () => {
      const isVisible = window.getComputedStyle(filterBox).display === "block";
      setFilterState(!isVisible);
    });
  } else {
    setFilterState(false);
    filterBtn.style.display = "none";
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".facets-vertical");
  const filterBtn = document.querySelector(".filter-cstm-title");

  if (!wrapper || !filterBtn) return;

  function updateLayout() {
    if (filterBtn.classList.contains("active")) {
      wrapper.classList.add("filters-open");
      wrapper.classList.remove("filters-closed");
    } else {
      wrapper.classList.add("filters-closed");
      wrapper.classList.remove("filters-open");
    }
  }

  updateLayout();

  filterBtn.addEventListener("click", () => {
    setTimeout(updateLayout, 10); 
  });
});


document.querySelectorAll('.mobile-facets__checkbox').forEach((el) => {
  el.addEventListener('change', function (e) {
    e.preventDefault(); // stop reload
  });
});


